function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3333 6.66669H4.66666C3.37983 6.66669 2.33333 7.71319 2.33333 9.00002V23C2.33333 24.2869 3.37983 25.3334 4.66666 25.3334H23.3333C24.6202 25.3334 25.6667 24.2869 25.6667 23V9.00002C25.6667 7.71319 24.6202 6.66669 23.3333 6.66669ZM23.3333 9.00002V9.59619L14 16.8564L4.66666 9.59735V9.00002H23.3333ZM4.66666 23V12.5514L13.2837 19.2539C13.488 19.4143 13.7402 19.5015 14 19.5015C14.2598 19.5015 14.512 19.4143 14.7163 19.2539L23.3333 12.5514L23.3357 23H4.66666Z",
  fill: "#060238"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2081 0.00942053C26.531 -0.182339 32.7899 2.55125 35.1779 8.40903C38.2357 15.91 39.1629 25.5831 32.5273 30.2289C26.0814 34.7419 17.9016 29.7968 11.9021 24.7053C7.40579 20.8896 5.91443 14.829 7.79435 9.23951C9.61168 3.83616 14.51 0.182233 20.2081 0.00942053Z",
  fill: "#4F71E0",
  fillOpacity: 0.08
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.9ecea96a.svg";
export { ForwardRef as ReactComponent };